import { paths } from "../../path";
import { useTranslation } from "react-i18next";
import A from "../A";
import React, { FC } from "react";

type MenuGuestProps = {
  onClick?: (() => void) | null;
  isActive?: boolean;
};

const MenuGuest: FC<MenuGuestProps> = ({ onClick = null, isActive = true }) => {
  const { t } = useTranslation("t");
  return (
    <A
      to={paths.login}
      big={true}
      colorContrast={"primary"}
      tabIndex={isActive ? null : -1}
      onClick={onClick}
    >
      {t("t:signIn", "__Sign_in")}
    </A>
  );
};

export default MenuGuest;
